/** Product generation (marketing); V5 was generation 1.0. */
export const APP_GENERATION = "1.5";
/** Semantic version of the workspace release. */
export const APP_VERSION = "10.3.0";
/** Human-readable label for UI + logs. */
export const APP_VERSION_LABEL = `Gen ${APP_GENERATION} · v${APP_VERSION}`;
/** Site footer / README copyright line. */
export const APP_COPYRIGHT = "Copyright jbg0801 2025–2026";
//# sourceMappingURL=version.js.map